module.exports = __webpack_public_path__ + "static/media/Downtown.be6891f9.jpg";